import { RECAPTCHA_KEY } from "@/constants/googleKeys";

let loadPromise = null;

const LOAD_TIMEOUT_MS = 15000;

function waitForReady(resolve, reject) {
  const timer = setTimeout(() => {
    reject(new Error("reCAPTCHA ready() timed out"));
  }, LOAD_TIMEOUT_MS);

  window.grecaptcha.ready(() => {
    clearTimeout(timer);
    resolve(window.grecaptcha);
  });
}

export function loadRecaptcha() {
  if (window.grecaptcha?.ready) {
    return new Promise((resolve, reject) => waitForReady(resolve, reject));
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`;

    script.onload = () => {
      if (!window.grecaptcha?.ready) {
        loadPromise = null;
        script.remove();
        reject(
          new Error("reCAPTCHA script loaded but grecaptcha is not available"),
        );
        return;
      }
      waitForReady(resolve, (err) => {
        loadPromise = null;
        reject(err);
      });
    };

    script.onerror = (err) => {
      loadPromise = null;
      script.remove();
      reject(err);
    };

    document.head.appendChild(script);

    setTimeout(() => {
      if (loadPromise) {
        loadPromise = null;
        reject(new Error("reCAPTCHA script load timed out"));
      }
    }, LOAD_TIMEOUT_MS);
  });

  return loadPromise;
}
